import React from "react";
import { useNavigate } from "react-router-dom";
import "../scss/notFound.scss";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="tree-animation">
          <div className="tree-trunk">
            <div className="tree-leaves">
              <span className="leaf">🍃</span>
              <span className="leaf">🍃</span>
              <span className="leaf">🍃</span>
              <span className="leaf">🍃</span>
              <span className="leaf">🍃</span>
            </div>
            <div className="tree-crown">🌳</div>
          </div>
        </div>

        <div className="error-message">
          <h1 className="error-code">404</h1>
          <h2 className="error-title">Oops! This branch doesn't exist</h2>
          <p className="error-description">
            It looks like you've wandered off the family tree path. This page
            might have been pruned or never grew here in the first place.
          </p>

          <div className="error-actions">
            <button className="btn-primary" onClick={() => navigate("/")}>
              🏠 Return to Root
            </button>
            <button className="btn-secondary" onClick={() => navigate(-1)}>
              ← Go Back
            </button>
          </div>
        </div>

        <div className="decorative-elements">
          <span className="floating-leaf">🍂</span>
          <span className="floating-leaf">🍂</span>
          <span className="floating-leaf">🍁</span>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
